import { LeadWhatsappMessage } from '../../../types';

export type ChatMessage = LeadWhatsappMessage & { isPending?: boolean };

// Junta as mensagens vindas do banco com o estado atual preservando a identidade dos objetos
// que não mudaram (para o React.memo do balão poupar re-renderizações) e mantendo as
// mensagens "enviando" que ainda não chegaram ao banco.
export function mergeMessages(prev: ChatMessage[], fromDb: ChatMessage[]): ChatMessage[] {
    const prevById = new Map(prev.map(m => [m.id, m]));
    const same = (a: ChatMessage, b: ChatMessage) =>
        a.status === b.status && a.media_url === b.media_url && a.message_body === b.message_body &&
        a.message_type === b.message_type && a.created_at === b.created_at && a.instance_id === b.instance_id;

    const merged = fromDb.map(m => {
        const old = prevById.get(m.id);
        return old && !old.isPending && same(old, m) ? old : m;
    });
    const dbIds = new Set(fromDb.map(m => m.id));
    const pending = prev.filter(m => m.isPending && !dbIds.has(m.id));
    const result = [...merged, ...pending];
    result.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());

    const unchanged = result.length === prev.length && result.every((m, i) => m === prev[i]);
    return unchanged ? prev : result;
}
